export { Tabs, TabsList, Tab, TabContent } from './tabs'
